<mat-toolbar>
    <mat-toolbar-row class="justify-content-between">
        <button mat-icon-button (click)="toggleSidebar()">
            <mat-icon>menu</mat-icon>
        </button>

        <div class="text">Please fill in the details below to initiate the activation process.Note that our support
            team will contact you after you've provided the required information for further assistance.</div>
        <div class="row mr-2 ml-auto">
            <ul>
                <li>
                    <button mat-button [matMenuTriggerFor]="menu" class="user mt-2 d-flex align-items-center">
                        <img src="../../../assets/images/1.png" class="user-image mr-1 p-2" />
                        <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu">
                        <img src="../../../assets/images/1.png" alt=" " class="user-image mr-1 p-2"
                            style="margin-left: 15px;" />John
                        <mat-divider></mat-divider>
                        <button mat-menu-item routerLink="/inactiveAll/myProfile">
                            <mat-icon>person</mat-icon>My Profile
                        </button>
                        <!-- <button mat-menu-item>
                                <mat-icon class="nav-icon">settings</mat-icon>Settings
                            </button> -->
                        <mat-divider></mat-divider>
                        <button mat-menu-item routerLink="/mainDashboard">
                            <mat-icon>exit_to_app </mat-icon>Logout
                        </button>
                    </mat-menu>
                </li>
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>